import MessagesIcon from "../../../assets/icons/MessagesIcon";
import Avatar from "../../../assets/images/avatar.svg";

type MemberProps = {
  name?: string;
  img?: string;
  handleIcon?: () => void;
};

export default function Member({
  name = "Name",
  img,
  handleIcon,
}: MemberProps) {
  return (
    <div className="flex justify-between items-center mb-2">
      <div className="flex items-center gap-4 flex-1">
        <img
          src={img || Avatar}
          className="w-9 h-9 object-cover rounded-full"
          alt="Avatar"
        />
        <span className="">{name}</span>
      </div>
      <div onClick={handleIcon}>
        <MessagesIcon />
      </div>
    </div>
  );
}
